/**
 * @description Création du slider kiosque
 */

const kiosque = document.querySelector(".kiosque__armentieres");
const jda = document.querySelector(".jda__armentieres");

const infiniteSlider = (root) => {
  const items = root.querySelectorAll(".kiosque__list__item") || null;
  const nbSlides = items.length;
  const bsBreakpoint = bsBreakpoints.detectBreakpoint();

  /**
   * @description Initialisation du slider
   */
  const initSlider = () => {
    // On set les order et la première slide active
    if (items) {
      items.forEach((item, index) => {
        if (index === 0) {
          item.classList.add("kiosque__list__item--active");
        } else if (index === 1) {
          item.classList.add("kiosque__list__item--next");
        } else if (index === 2) {
          item.classList.add("kiosque__list__item--prev");
        }
      });
    }
    createNav();
  };

  /**
   * @description Gestion du touch
   */

  const sliderTouch = (slide) => {
    slide.addEventListener("touchstart", (e) => {
      startDrag(e);
    });

    slide.addEventListener("touchmove", (e) => {
      drag(e);
    });

    slide.addEventListener("touchend", (e) => {
      endDrag(e);
    });
    let origin;
    let lastTranslate;

    /**
     * @description Démarre la detection au toucher
     */

    const startDrag = (e) => {
      if (e.touches) {
        if (e.touches.length > 1) {
          return;
        } else {
          e = e.touches[0];
        }
      }
      origin = { x: e.screenX, y: e.screenY };
    };

    /**
     * @description Déplacement au toucher
     */
    const drag = (e) => {
      if (origin) {
        let point = e.touches ? e.touches[0] : e;
        let translate = {
          x: point.screenX - origin.x,
          y: point.screenY - origin.y,
        };
        lastTranslate = translate;
      }
    };

    const endDrag = (e) => {
      if (origin && lastTranslate) {
        if (
          e.touches &&
          Math.abs(lastTranslate.x) > Math.abs(lastTranslate.y)
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (lastTranslate.y < 100 && lastTranslate.y > -100) {
          let current = root.querySelector(".kiosque__list__item--active");
          let prev = root.querySelector(".kiosque__list__item--prev");
          let next = root.querySelector(".kiosque__list__item--next");
          let direction;
          // Permet d'empecher le slide si on scroll verticalement
          if (lastTranslate.x < -100) {
            direction = "next";
          } else if (lastTranslate.x > 100) {
            direction = "prev";
          }
          useNav(direction, prev, next, current);
        }
      }
      origin = null;
      lastTranslate = null;
    };
  };

  /**
   * @description Création de la nav du slider
   */
  const createNav = () => {
    let nav = `<button class="kiosque__list__btn btn-prev"><span class="sr-only">${ModuloTS["Previous slide"]}</span></button>
       <button class="kiosque__list__btn btn-next"><span class="sr-only">${ModuloTS["Next slide"]}</span></button>`;
    const wrapper = root.querySelector(".kiosque-wrapper");
    wrapper.insertAdjacentHTML("afterbegin", nav);

    if (
      bsBreakpoint === "xSmall" ||
      bsBreakpoint === "small" ||
      bsBreakpoint === "medium"
    ) {
      items.forEach((slide) => {
        sliderTouch(slide);
      });
    }
  };

  /**
   * @description Gestion du translate
   */
  const translate = () => {
    const btns = root.querySelectorAll(".kiosque__list__btn");
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        let current = root.querySelector(".kiosque__list__item--active");
        let prev = root.querySelector(".kiosque__list__item--prev");
        let next = root.querySelector(".kiosque__list__item--next");
        let direction;

        btn.classList.contains("btn-next")
          ? (direction = "next")
          : (direction = "prev");

        useNav(direction, prev, next, current);
      });
    });
  };

  /**
   * @description Ecoute des boutons
   */
  const useNav = (direction, prev, next, current, device) => {
    items.forEach((slide) => {
      slide.classList.remove(
        "kiosque__list__item--prev",
        "kiosque__list__item--active",
        "kiosque__list__item--next"
      );
    });

    items.forEach((slide) => {
      slide.classList.add("item-animated");
      slide.addEventListener("transitionend", () => {
        slide.classList.remove("item-animated");
        if (slide.classList.contains("kiosque__list__item--active")) {
          slide.querySelector("a").setAttribute("tabindex", "0");
        } else {
          slide.querySelector("a").setAttribute("tabindex", "-1");
        }
      });
    });
    if (direction === "next") {
      next.classList.add("kiosque__list__item--active");
    } else {
      prev.classList.add("kiosque__list__item--active");
    }
    current = root.querySelector(".kiosque__list__item--active") || null;

    current.nextElementSibling
      ? current.nextElementSibling.classList.add(`kiosque__list__item--next`)
      : items[0].classList.add("kiosque__list__item--next");
    current.previousElementSibling
      ? current.previousElementSibling.classList.add(
          "kiosque__list__item--prev"
        )
      : items[nbSlides - 1].classList.add("kiosque__list__item--prev");
  };

  initSlider();
  translate();
};

const init = () => {
  infiniteSlider(kiosque);
  infiniteSlider(jda);
};

init();
